import { jsx as _jsx } from "react/jsx-runtime";
import { IconButton, Tooltip } from '@dixa/lib-shared-habla';
export const SettingsIntegrationsDocumentationButton = ({ tooltipContent = 'Help and documentation', onClick, }) => {
    return (_jsx(Tooltip, Object.assign({ content: tooltipContent, dark: true }, { children: _jsx(IconButton, { icon: "question", variant: "tertiary", onClick: onClick }) })));
};
